export default class DualloUserViewModel {
  organizationId = null;
  id = null;
  acceptedTermsOfService = false;
  termsAcceptedOn = false;
  eTag = null;

  constructor(data) {
    this.organizationId = data.organizationId;
    this.id = data.id;
    this.acceptedTermsOfService = data.acceptedTermsOfService;
    this.termsAcceptedOn = data.termsAcceptedOn;
    this.eTag = data.eTag;
  }
}